<template>
  <div class="text-xs-center">
    <v-dialog v-model="dialog" persistent width="1000">
      <v-card>
        <div class="truck-editor-content" v-if="truck != null">
          <truck-top
            class="truck-top"
            ref="truckTop"
            :orders="truckOrders"
            :selectedTruck="truck"
            :divider="divider"
            :manualUpdate="true"
            :allPallets="allPallets"
            @dragStart="startedDragging = true"
            @dropped="updatePermissions"
            @updated="updateScreen()"
          ></truck-top>
          <div class="rearrange-buttons" v-if="startedDragging">
            <v-icon
              large
              v-tooltip="$t('priority_controls.rearrange_truck')"
              color="deep-purple lighten-1"
              :disabled="rearrangeDisabled"
              @click="rearrangePallets"
            >call_made</v-icon>
            <v-icon
              large
              color="deep-purple lighten-1"
              v-tooltip="$t('priority_controls.save_arrangement')"
              :disabled="rearrangeSaveDisabled"
              @click="saveRearrange"
            >save</v-icon>
          </div>
          <div class="priority-controls">
            <priority-controls
              ref="priorityControls"
              :truck="truck"
              :orders="truckOrders"
              @updated="updateScreen()"
            ></priority-controls>
          </div>
        </div>
        <div class="exit-button">
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn color="red" @click="dialog = false" v-on="on">
                <v-icon color="white">close</v-icon>
              </v-btn>
            </template>
            <span>{{ $t("truck_edit.close") }}</span>
          </v-tooltip>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import TruckTop from "@/components/palleting/TruckTop.vue";
import PriorityControls from "@/components/palleting/PriorityControls.vue";
import Truck from "@/models/Truck.js";
export default {
  props: {
    orders: {
      type: Array,
      required: true
    },
    allPallets: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      truck: null,
      divider: null,
      dialog: false,
      rearrangeDisabled: true,
      rearrangeSaveDisabled: true,
      startedDragging: false
    };
  },
  watch: {
    dialog(val) {
      if (!val) {
        this.truck = null;
      } else {
        document.addEventListener("keyup", e => {
          if (e.key === "Escape") {
            this.dialog = false;
          }
        });
      }
    }
  },
  computed: {
    truckOrders() {
      let orders = [];
      this.orders.forEach(order => {
        if (order.inTruck(this.truck)) {
          orders.push(order);
        }
      });
      return orders;
    }
  },
  methods: {
    open(truck) {
      const newTruck = new Truck(truck);
      this.divider = this.getDivider(newTruck);
      this.truck = newTruck;
      this.rearrangeDisabled = this.truck.status >= 4;
      this.rearrangeSaveDisabled = this.truck.status >= 4;
      this.dialog = true;
    },
    updateTruck(truck) {
      const newTruck = new Truck(truck);
      this.divider = this.getDivider(newTruck);
      this.truck = newTruck;
      this.rearrangeDisabled = this.truck.status >= 4;
      this.rearrangeSaveDisabled = this.truck.status >= 4;
      this.$refs.truckTop.initialize();
    },
    updateScreen() {
      this.$emit("truckUpdated", this.truck);
    },
    update(trucks) {
      if (!this.dialog) return;
      const truck = trucks.find(e => {
        return e.id === this.truck.id;
      });

      if (truck) {
        this.truck = truck;
        this.rearrangeDisabled = this.truck.status >= 4;
        this.rearrangeSaveDisabled = this.truck.status >= 4;
        this.divider = this.getDivider(truck);
        this.$refs.priorityControls.initialize();
      }
    },
    getDivider(truck) {
      let divider = 10;
      divider = Math.max(divider, truck.getLength() / 900);
      return divider;
    },

    rearrangePallets() {
      this.rearrangeSaveDisabled = true;
      this.rearrangeDisabled = true;
      this.$refs.truckTop.rearrange();
    },

    saveRearrange() {
      this.$refs.truckTop.saveRearrange();
      this.startedDragging = false;
    },

    updatePermissions(truck) {
      this.rearrangeDisabled = truck.intersectingPallets() || truck.status >= 4;
      this.rearrangeSaveDisabled = !truck.palletsFit() || truck.status >= 4;
    }
  },
  components: {
    TruckTop,
    PriorityControls
  }
};
</script>

<style>
.truck-editor-content {
  min-height: 850px;
}
.priority-controls {
  width: 100%;
  padding-top: 30px;
  padding-left: 10px;
}
.truck-top {
  position: relative;
  width: calc(100% - 50px);
  left: 50px;
  top: 25px;
}
.exit-button {
  position: absolute;
  right: 10px;
  bottom: 10px;
}
.rearrange-buttons {
  position: absolute;
  top: 30px;
  left: 10px;
  width: 30px;
}
</style>
